import cn from 'classnames';
import { Button, FCX, getRem, Portal, Tooltip } from '@datassential/platform-ui-lib';
import { MdTune } from 'react-icons/md';
import { useFilters } from './SelectFiltersContext';
import SelectFiltersModal from './SelectFiltersModal';

const SelectFilters: FCX = ({
    className,
    testId,
}) => {
    const { openFiltersPopup, filtersText } = useFilters();

    return (
        <>
            <Button
                className={cn(
                    'SelectFilters__button',
                    'Indicatable',
                    className,
                    {
                        'is-applied': filtersText !== "",
                    }
                )}
                onClick={openFiltersPopup}
                data-testid={testId ?? 'buttonSelectFilters'}
                data-tooltip-id="select-filters-tooltip"
            >
                <MdTune style={{ width: getRem(22), height: getRem(22) }}/>
                &nbsp; FILTERS
            </Button>
            {!!filtersText && (
                <Portal>
                    <Tooltip id="select-filters-tooltip" place="top-end">
                        <div
                            className="SelectFilters__tooltip"
                            dangerouslySetInnerHTML={{
                                __html: filtersText,
                            }}
                        />
                    </Tooltip>
                </Portal>
            )}

            <SelectFiltersModal/>
        </>
    );
};

export default SelectFilters;